<template>
  <div :class="['form-group mb-0', customClass.containerClass]">
    <label v-if="label" :for="id" :class="customClass.labelClass">{{
      label
    }}</label>
    <div class="position-relative">
      <div class="side-label">+62</div>
      <input
        :id="id"
        type="number"
        :class="['form-control pr-4', customClass.inputClass]"
        :placeholder="placeholder"
        v-model="currentValue"
        @blur="onblur"
        @input="onchange"
      />
    </div>
    <small class="text-danger m-0" v-if="currentError">{{
      currentError
    }}</small>
  </div>
</template>

<script>
import { validateIndonesianPhoneNumber } from "../../utils";

export default {
  data() {
    return {
      currentError: this.error,
      currentValue: this.value,
    };
  },
  props: {
    customClass: {
      type: Object,
      default: () => ({ containerClass: "", labelClass: "", inputClass: "" }),
    },
    id: { type: String, required: true },
    value: { type: String, required: true },
    placeholder: { type: String, default: "", required: false },
    error: { type: String, default: "", required: false },
    label: { type: String, default: "", required: false },
    required: { type: Boolean, default: false },
  },
  methods: {
    onchange(event) {
      if (event.target.value) this.currentError = "";
      this.$emit("change", event.target.value);
    },
    onblur(event) {
      if (this.required && !event.target.value) {
        this.currentError = "This field is required";
      } else {
        const isValid = validateIndonesianPhoneNumber(event.target.value);
        this.currentError = isValid ? "" : "Phone number is not valid";
      }
      this.$emit("blur", event.target.value);
    },
  },
  watch: {
    error(val) {
      this.currentError = val;
    },
    value(val) {
      this.currentValue = val;
    },
  },
};
</script>

<style scoped>
input {
  width: 100%;
  padding-left: 3.5rem;
  font-size: 1rem;
  border-radius: 6px;
}

/* Chrome, Safari, Edge, Opera */
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  appearance: textfield;
  -moz-appearance: textfield;
}

label {
  color: #374151;
  font-weight: 600;
  font-size: 14px;
}

.text-muted,
input::placeholder {
  font-size: 1rem;
  color: #2e364666 !important;
  opacity: 1 !important; /* Firefox */
}

.side-label {
  position: absolute;
  top: 50%;
  left: 12px;
  transform: translateY(-50%);
  color: #6b7280; /* Gray-500 */
  font-size: 14px;
  pointer-events: none;
  border-right: 1px solid #d1d5db; /* Gray-300 */
  padding-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Input/InputPhone.vue